import React from 'react';
import { Navigate } from 'react-router-dom';

function ConsoleProtectedRoute({ children }) {
  // Check if console token exists
  const isConsoleAuthenticated = () => {
    return !!localStorage.getItem('consoleToken');
  };

  if (!isConsoleAuthenticated()) {
    // Redirect to console login if not authenticated
    return <Navigate to="/console/login" replace />;
  }

  // No navbar for console - render children directly
  return children;
}

export default ConsoleProtectedRoute;
